import * as React from 'react';
import { useBookingDetailedView } from 'Hooks/useBookingDetailedView';
import { Navigate } from 'react-router-dom';
import { LottieSpinner } from '../../Lottie/LottieSpinner';
import BookingDetailedViewInner from './BookingDetailedViewInner';

export type EditType =
	| 'vehicle'
	| 'passenger'
	| 'passenger-details'
	| 'seating'
	| 'trip-time'
	| 'route-direction'
	| 'add-on'
	| 'other'
	| 'event-date-time'
	| 'event-contact'
	| 'custom-ticket'
	| 'tickets'
	| 'freight-details'
	| 'freight-contact-details'
	| 'event-calendar'
	| 'event-details';

export interface BookingDetailsProps {
	bookingId: string;
}

export const BookingDetailedView = ({ bookingId }: BookingDetailsProps) => {
	const { response } = useBookingDetailedView(bookingId);

	if (response.type === 'loading' || response.type === 'error') {
		return <LottieSpinner />;
	}

	if (!response.data) {
		return <Navigate to="/404" />;
	}

	return <BookingDetailedViewInner booking={response.data} refresh={response.refresh} />;
};
